/** Shared account-access policy for web and VR. Backend enforces every write.
 * Full admin has ONE authority: the account flag. Legacy role names are not
 * aliases here: a revoked privilege must not survive in a cached role list.
 */
export interface AccessIdentity {
  is_superuser?: boolean
  isSuperuser?: boolean
  roles: readonly string[]
}

export function isAdministrator(user: AccessIdentity | null | undefined): boolean {
  return user?.is_superuser === true || user?.isSuperuser === true
}

export function canManageDevices(user: AccessIdentity | null | undefined): boolean {
  return isAdministrator(user) || !!user?.roles.includes('device_admin')
}

export function canAccessAdminShell(user: AccessIdentity | null | undefined): boolean {
  return canManageDevices(user)
}

export function hasDemoAccess(user: AccessIdentity | null | undefined): boolean {
  return isAdministrator(user) || !!user?.roles.includes('tester')
}

/** Development superadmin is narrower than operational Admin. */
export function isDeveloperAdmin(user: AccessIdentity | null | undefined): boolean {
  return isAdministrator(user) && !!user?.roles.includes('developer')
}
